import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  background: #f5f5f5;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
`

export const Wrapper = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    flex-direction: column;
    row-gap: ${({ theme }) => theme.typography.pxToRem(28)};
  }
`

export const TitleContainer = styled.div``

export const Title = styled(Typography)`
  color: #607370;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.32px;
  text-transform: uppercase;
  opacity: 0.5;
`

export const LogosContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(100)};
`

export const Logo = styled(CustomImage)``
